module.exports = __webpack_public_path__ + "static/flooding-map-d4f191cf994fcfb55de98b6f4fbf3be8.jpg";